import { render, staticRenderFns } from "./JBProposalOutdoorRisk.vue?vue&type=template&id=27f7f432"
import script from "./JBProposalOutdoorRisk.vue?vue&type=script&lang=js"
export * from "./JBProposalOutdoorRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports